"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FaqText = exports.FdrAccordionItemWrapper = exports.FaqSectionWrapper = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const fdr_regular_fusion_fdr_accordion_1 = require("@hotelplan/fdr.regular.fusion.fdr-accordion");
const util_theme_sxc_1 = require("@hotelplan/util.theme.sxc");
exports.FaqSectionWrapper = styled_components_1.default.div((0, util_theme_sxc_1.sx2CssThemeFn)({
    fontSize: [null, 3],
    mx: [-3, 'auto'],
    '.accordionItem:not(:last-child)': {
        '.accordionButton': {
            borderBottom: 'none',
        },
    },
    '.accordionButton': {
        pl: ['20px', 4],
        pr: '20px',
        borderColor: 'borderColor',
    },
    '.accordionButton.active': {
        backgroundColor: 'lightGreySecond',
        borderBottom: 'none',
    },
    '.accordionContent.active': {
        backgroundColor: 'lightGreySecond',
        mx: 3,
    },
    '.accordionContent': {
        px: [1, '10px'],
    },
}));
exports.FdrAccordionItemWrapper = (0, styled_components_1.default)(fdr_regular_fusion_fdr_accordion_1.FdrAccordionItem)(({ fontColor, bgColor }) => ({
    '.accordionButton.active, .accordionContent.active': {
        backgroundColor: bgColor,
        color: fontColor,
    },
    '.accordionButton': {
        backgroundColor: bgColor,
        color: fontColor,
    },
}));
exports.FaqText = styled_components_1.default.div(({ theme }) => theme.text.richText, (0, util_theme_sxc_1.sx2CssThemeFn)({
    p: 3,
}));
//# sourceMappingURL=fdr-faq.styles.js.map